import * as actionTypes from './types';
import axios from 'axios';

import {
  storeUsername,
  deleteJourneyBusinessChallenge,
  deleteJourneyPersonas,
  deleteJourneyMilestones,
  deleteJourneyIdeas,
  deleteJourneyMilestoneConnectors,
  setBusinessChallenge,
  addPersona,
  addMilestone,
  updateMilestoneConnectorOrder,
  updateMilestonePersona,
  updateMilestoneProduct,
  retrieveIdeas,
  retrieveMilestoneConnectors,
  setStepId,
  deleteJourneyCollaborators,
} from './index';

export const loadJourneysFromDB = () => async (dispatch) => {
  try {
    const sessionRes = await axios.get('/api/session');
    const { username } = sessionRes.data;
    dispatch(storeUsername(username));

    const journeyRes = await axios.get('/api/journey/username/');
    const { journeys } = journeyRes.data;
    dispatch(setJourneys(journeys));

    const collaboratorJourneyRes = await axios.get('/api/collaborator/userid');
    const { collaborations } = collaboratorJourneyRes.data;

    if (collaborations.length > 0) {
      let collabJourneys = [];
      await collaborations.forEach(async (collab) => {
        const journeyTemp = await axios.get(
          `/api/journey/${collab.journey_id}`
        );

        collabJourneys.push(journeyTemp.data.journey);

        if (collabJourneys.length === collaborations.length) {
          dispatch(setCollaboratorJourneys(collabJourneys));
        }
      });
    } else {
      dispatch(setCollaboratorJourneys([]));
    }
  } catch (error) {
    console.log('Journey Error:', error);
  }
};

export const setJourneys = (journeyArray) => ({
  type: actionTypes.SET_JOURNEYS,
  journeys: journeyArray,
});

export const setIsCollaborator = (isCollaborator) => ({
  type: actionTypes.SET_IS_COLLABORATOR,
  isCollaborator: isCollaborator,
});

export const setCollaboratorJourneys = (collaboratorJourneyArray) => ({
  type: actionTypes.SET_COLLABORATOR_JOURNEYS,
  collaboratorJourneys: collaboratorJourneyArray,
});

export const storeJourneyId = (journeyId) => ({
  type: actionTypes.STORE_JOURNEY_ID,
  journeyId: journeyId,
});

export const storeJourneyName = (journeyName) => ({
  type: actionTypes.STORE_JOURNEY_NAME,
  journeyName: journeyName,
});

export const storeIndustryName = (industryName) => ({
  type: actionTypes.STORE_INDUSTRY_NAME,
  industryName: industryName,
});

export const storeChecklistDB = (journeyId, checklistItem, value) => {
  return (dispatch) => {
    axios
      .post('/api/journey/checklist', {
        id: journeyId,
        checklistItem: checklistItem,
        value: value,
      })
      .then((result) => {
        if (checklistItem === 1)
          dispatch(storeChecklistOne(result.data.saved.checklist_one));
        else if (checklistItem === 2)
          dispatch(storeChecklistTwo(result.data.saved.checklist_two));
      })
      .catch((error) => {
        console.log('ERROR: ', error);
      });
  };
};

export const storeChecklistOne = (checklistOne) => ({
  type: actionTypes.STORE_CHECKLIST_ONE,
  checklistOne: checklistOne,
});

export const storeChecklistTwo = (checklistTwo) => ({
  type: actionTypes.STORE_CHECKLIST_TWO,
  checklistTwo: checklistTwo,
});

export const deleteJourney = (journeyId) => {
  return axios
    .delete(`/api/journey/${journeyId}`)
    .then((result) => {
      console.log(result);
    })
    .catch((error) => {
      console.log(error);
    });
};

export const deleteJourneyCollaborator = (journeyId) => {
  return (dispatch) => {
    axios
      .delete(`/api/collaborator/${journeyId}`)
      .then((result) => {
        console.log(result);
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const deleteJourneyAndRelated = (journeyId) => async (dispatch) => {
  if (!Number.isNaN(parseInt(journeyId))) {
    await Promise.all([
      dispatch(deleteJourneyCollaborators(journeyId)),
      dispatch(deleteJourneyBusinessChallenge(journeyId)),
      dispatch(deleteJourneyPersonas(journeyId)),
      dispatch(deleteJourneyMilestones(journeyId)),
      dispatch(deleteJourneyIdeas(journeyId)),
      dispatch(deleteJourneyMilestoneConnectors(journeyId)),
      //delete collaborators here- don't throw error if no collabs
      dispatch(deleteJourney(journeyId)),
    ]);
    await dispatch(loadJourneysFromDB());
  }
};

export const updateJourneyCompleted = (journeyId) => {
  return (dispatch) => {
    axios
      .get(`/api/journey/${journeyId}`)
      .then((result) => {
        axios
          .put(`/api/journey/${journeyId}`, {
            id: journeyId,
            name: result.data.journey.name,
            email: result.data.journey.email,
            journey_name: result.data.journey.journey_name,
            industry_name: result.data.journey.industry_name,
            deal_size: result.data.journey.deal_size,
            finished: true,
          })
          .then((result) => {
            dispatch(setJourneyCompleted(true));
          })
          .catch((error) => {
            console.log(error);
          });
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

export const setJourneyCompleted = (journeyCompleted) => ({
  type: actionTypes.SET_JOURNEY_COMPLETED,
  journeyCompleted: journeyCompleted,
});

export const loadJourneyAndRelated = (journeyId) => async (dispatch) => {
  try {
    const { data } = await axios.get(`/api/journey/${journeyId}/related`);

    if (data) {
      dispatch(setBusinessChallenge(data.businessChallenge));
      for (const persona of data.personas) {
        dispatch(addPersona(persona.id, persona.name, persona.role, persona.hero, persona.pic_url));
      }

      for (const milestone of data.milestones) {
        dispatch(
          addMilestone(milestone.position, milestone.id, milestone.content)
        );
        dispatch(
          updateMilestoneProduct(
            milestone.position,
            milestone.product_ids || []
          )
        );
        dispatch(
          updateMilestonePersona(
            milestone.position,
            milestone.persona_ids || []
          )
        );
        dispatch(
          updateMilestoneConnectorOrder(
            milestone.position,
            milestone.connector_ids || []
          )
        );
      }

      dispatch(retrieveIdeas(journeyId));
      dispatch(retrieveMilestoneConnectors(journeyId));
      dispatch(storeJourneyId(journeyId));
      dispatch(setStepId(data.navigation_stage || 0));
      dispatch(storeChecklistOne(data.checklist_one));
      dispatch(storeChecklistTwo(data.checklist_two));
      dispatch(setJourneyCompleted(data.finished));
      dispatch(storeIndustryName(data.industry_name));
      dispatch(storeJourneyName(data.journey_name));
      // journey name
      // date created
      console.log(data);
    }
  } catch (err) {
    console.log(err);
  }
};

export const startJourney = (journeyInfo) => async (dispatch) => {
  const {
    oppId,
    journeyName,
    industryName,
    collaborators,
    pillOptions,
  } = journeyInfo;

  try {
    const sessionRes = await axios.get('/api/session');
    const { username, name } = sessionRes.data;

    const journeyRes = await axios.post('/api/journey', {
      name: name,
      email: username,
      journey_name: journeyName,
      industry_name: industryName,
      finished: false,
      oppId: oppId,
      collaborators: collaborators,
      pillOptions: pillOptions,
    });

    const { id, journey_name, industry_name } = journeyRes.data.attributes;

    dispatch(storeUsername(username));
    dispatch(storeJourneyId(id));
    dispatch(storeJourneyName(journey_name));
    dispatch(storeIndustryName(industry_name));
  } catch (error) {
    console.log('Journey Error:', error);
  }
};
